import * as R from "ramda";
import { call, put, select, takeEvery } from "redux-saga/effects";
import { actionTypes } from "./constants";
import { fetchFlagsSuccess, fetchFlagsFailure } from "./actions";
import api from "./api";
import { getCredentials } from "redux/modules/user/selectors";

const getParams = function*(stateConfig) {
  const credentials = yield select(getCredentials);

  const params = {
    credentials,
    email: stateConfig?.user?.email,
    userId: stateConfig?.user?.custom?.userId,
    currentEventId: stateConfig?.user?.custom?.currentEventId,
    currentOrgId: stateConfig?.user?.custom?.currentOrgId
  };

  // Filter out null/undefined values
  return R.pickBy(val => val !== null && val !== undefined, params);
};

function* fetchFlags({ payload: stateConfig }) {
  try {
    const { credentials, ...params } = yield call(getParams, stateConfig);

    if (!credentials || !params.userId) {
      return;
    }

    const response = yield call(api.getFlags, credentials, params);
    yield put(fetchFlagsSuccess(response.payload));
  } catch (error) {
    yield put(fetchFlagsFailure(error.message));
  }
}

export function* initSaga() {
  yield takeEvery(actionTypes.FETCH_FLAGS_REQUEST, fetchFlags);
}
